import '@babel/polyfill'
import DefaultApp from 'components/app/default-app'
import api from 'libs/api'
import perf from 'libs/perf'
import { DateTime, Settings } from 'luxon'
import 'raf/polyfill'
import { Provider } from 'react-redux'
import 'whatwg-fetch'
import './index.css'
import store from './store'

perf.measureNow(
  'browser:ready',
  'browser finished loading application resources'
)

if (!DateTime.local().locale.startsWith('en')) {
  Settings.defaultLocale = 'en'
}

// Register remote control keys on Samsung Tizen devices
if (typeof tizen !== 'undefined' && tizen.tvinputdevice) {
  const keys = [
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    'ChannelUp',
    'ChannelDown',
    'ColorF0Red',
    'ColorF1Green',
    'ColorF2Yellow',
    'ColorF3Blue',
    'MediaRewind',
    'MediaFastForward',
    'MediaPlay',
    'MediaPause',
    'MediaStop',
    'Info',
    'Guide'
  ]
  if (tizen.tvinputdevice.registerKeyBatch) {
    tizen.tvinputdevice.registerKeyBatch(keys)
  } else {
    for (let key in keys) {
      tizen.tvinputdevice.registerKey(key)
    }
  }
}

export default () => (
  <Provider store={store}>
    {api.ready() ? (
      <DefaultApp />
    ) : (
      <div style={{ padding: '40px 20px', textAlign: 'center' }}>
        Error: application not properly set up!
      </div>
    )}
  </Provider>
)
